import { Store, select } from '@ngrx/store';
import * as fromCard from '../state/selectors';
var SelectedCardQuery = /** @class */ (function () {
    function SelectedCardQuery(store) {
        this.store = store;
    }
    Object.defineProperty(SelectedCardQuery.prototype, "values", {
        get: function () {
            return this.store.pipe(select(fromCard.getSelectedCard));
        },
        enumerable: true,
        configurable: true
    });
    return SelectedCardQuery;
}());
export { SelectedCardQuery };
